<template>
  <div
    class="event-bd tb"
    v-if="funcView.mal_fun_list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        class="search-form"
        @submit.native.prevent
      >
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            v-if="funcView.mal_fun_add"
            @click="addEvent"
          >{{ funcView.mal_fun_add }}</el-button>
        </el-form-item>
        <!-- <el-form-item v-if="funcView.mal_fun_notify_setting">
          <el-button
            type="primary"
            @click="onNotifySetting"
          ><i class="icon icon-jichupeizhiguanli"></i> {{funcView.mal_fun_notify_setting}}</el-button>
        </el-form-item> -->
        <el-form-item
          v-if="funcView.mal_fun_export"
          style="float: right; margin-right: 0"
        >
          <el-button
            class="table-set"
            @click="exportTable"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('dms_event.V3dai_maV4dai_ma')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <!-- 语种 -->
        <el-form-item style="float: right">
          <custom-select
            :placeholder="$t('dms_event.yu_zhong')"
            code="language_type"
            v-model="formSearch.langCode"
            @change="onPageChange({page: 1})"
          ></custom-select>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onSearch"
      @clear="clearFilter('')"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <!-- <el-form-item :label="$t('page_event_cpxh')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            width="100%"
          ></custom-select>
        </el-form-item> -->
        <el-form-item :label="$t('dms_event.bu_jian_ming_cheng')">
          <el-input v-model="formSearch.componentName"></el-input>
        </el-form-item>

      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        :data="tableColumn.length ? eventList : []"
        row-key="funcId"
        height="100%"
        @filter="filterChange"
        @sort="sortChange"
        :column="tableColumn"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        :slots="['faultName', 'customerMedia', 'serviceMedia', 'action']"
      >
        <template v-slot:faultName="scope">
          <span
            v-if="funcView.mal_fun_view"
            @click="seeEvent(scope.row)"
            style="color: #00a2df; cursor: pointer"
          >{{ scope.row.faultName }}</span>
          <span v-else>{{ scope.row.faultName }}</span>
        </template>
        <template v-slot:customerMedia="scope">
          <el-button
            type="text"
            size="mini"
            @click="previewFile(scope.row, 'customerMedia')"
          >{{ $t('Common.com_detail') }}</el-button>
        </template>
        <template v-slot:serviceMedia="scope">
          <el-button
            type="text"
            size="mini"
            @click="previewFile(scope.row, 'serviceMedia')"
          >{{ $t('Common.com_detail') }}</el-button>
        </template>
        <template v-slot:action="scope">
          <span>
            <el-button
              type="text"
              size="mini"
              v-if="funcView.mal_fun_edit"
              @click="editEvent(scope.row)"
            >{{ funcView.mal_fun_edit }}</el-button>
            <el-button
              type="text"
              size="mini"
              v-if="funcView.mal_fun_delete"
              @click="deleteEvent(scope.row)"
            >{{ funcView.mal_fun_delete }}</el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <!-- 分页 -->
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <event-item-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @add="getEventPage"
      @edit="getEventPage"
      @close="dialogVisible = false"
    ></event-item-dialog>
    <!-- 附件预览 -->
    <img-detail-dialog
      v-if="showFilePreview"
      @close="showFilePreview = false"
      :bizData="filePreviewData"
      :title="filePreviewTitle"
    ></img-detail-dialog>
    <!-- 事件通知设置 -->
    <notify-setting-dialog
      v-if="dialogVisible2"
      :model="dialogModel2"
      @close="dialogVisible2 = false"
    ></notify-setting-dialog>
    <!-- 客户处理方案/售后处理方案 -->
    <!-- <device-detail-fault-more
      v-if="dialogVisible3"
      @close="dialogVisible3 = false"
      :model="dialogModel3"
    ></device-detail-fault-more> -->
    <!-- 查看处理方案 -->
    <check-programme-dialog
      v-if="dialogVisible4"
      @close="dialogVisible4 = false"
      :model="dialogModel4"
    ></check-programme-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import Cookies from 'js-cookie';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';

import eventItemDialog from './children/event_item_dialog';
import notifySettingDialog from './children/notify_setting_dialog';
import checkProgrammeDialog from './children/check_programme_dialog';

export default {
  name: 'alarm',
  mixins: [resetFormSearchMixins],
  components: { eventItemDialog, notifySettingDialog, checkProgrammeDialog },
  computed: {
    langCode() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.langCode : '';
    }
  },
  data() {
    return {
      tableCode: 'iot_event_code',
      formSearch: {
        search: '',
        pageNum: 1,
        pageSize: 50,

        // 高级搜索
        // 语种
        langCode: '',
        // 产品型号
        productCode: '',
        // 部件名称
        componentName: '',
      },

      // 参数
      dialogVisible: false,
      dialogModel: {},

      eventList: [],
      totalRows: 0,

      // 附件预览
      showFilePreview: false,
      filePreviewData: [],
      filePreviewTitle: '',
      // 通知设置
      dialogVisible2: false,
      dialogModel2: {},

      // 方案详情
      dialogVisible3: false,
      dialogModel3: {},

      // 查看方案
      dialogVisible4: false,
      dialogModel4: {},
      link: null,
    };
  },
  watch: {

  },
  mounted: function () {
    this.formSearch.langCode = Cookies.get('langCode') || 'CN';
    this.getEventPage();
    this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

  },
  methods: {
    onNotifySetting() {
      this.dialogVisible2 = true;
    },
    // 预览附件
    // previewFile(row, type) {
    //   const { eventId } = row;
    //   // 客户处理附件
    //   if (type === 'customerMedia') {
    //     const bizData = [{ bizId: eventId, bizType: 'event_customer_media' }];
    //     this.filePreviewData = bizData;
    //     this.filePreviewTitle = '客户处理附件';
    //   } else {
    //     const bizData = [{ bizId: eventId, bizType: 'event_service_media' }];
    //     this.filePreviewData = bizData;
    //     this.filePreviewTitle = '售后处理附件';
    //   }
    //   this.showFilePreview = true;
    // },
    previewFile(row) {
      // this.dialogModel3 = {
      //   data: row
      // };
      // this.dialogVisible3 = true;
      this.dialogModel4 = {
        title: this.$t('dms_event.ckclfa'),
        data: row,
      };
      this.dialogVisible4 = true;
    },
    onSearch() {
      this.getEventPage();
    },
    exportTable() {
      this.$exportFlie(apis.eventExport, this.formSearch).then(() => { });
    },
    // 获取设备事件列表
    getEventPage: function () {
      this.$getJSON(apis.eventPage, this.formSearch).then((res) => {
        this.eventList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 新增
    addEvent: function () {
      this.dialogModel.type = 'add';
      this.dialogVisible = true;
    },
    // 编辑
    editEvent: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    // 删除
    deleteEvent: function (row) {
      this.$showConfirm(this.$t('dms_event.nqdyscxzdsjdmm')).then(() => {
        this.$postJSON(`${apis.eventDelete}/${row.eventId}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success'),
          });
          this.getEventPage();
        });
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getEventPage();
    },
  },
};
</script>

<style lang="scss">
.event-bd {
  .search-form {
    .el-form-item__content {
      width: 100%;
    }
  }
}
</style>
